// Sections
import Hero from "./sections/Hero";
import Services from "./sections/Services";
import SubSection from "./sections/SubSection";

const Home = () => {
  return (
    <>
      <Hero />
      <SubSection />
      <Services />
    </>
  );
};

export default Home;
